import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { Simulation } from '../Simulation.ts';
import { SimulationApi } from '../../../apis/SimulationApi/SimulationApi.ts';

export function useGetDefaultSimulation(patientId?: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.defaultSimulation, patientId],
        queryFn: async () => {
            const result = await SimulationApi.getDefaultSimulation(patientId!);
            return new Simulation(result);
        },
        enabled: !!patientId,
    });
}
